export default __webpack_public_path__ + "static/media/logotipo.2717fcc4.svg";